import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
  height: 56px;
  padding: 0 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${Color.White};
  border: 1px solid ${Color.Gray300};
`;

export const ValuesContainer: StyledComponent<'div'> = styled.div`
  color: ${Color.Gray500};
  font-size: 14px;
  line-height: 18px;
  font-weight: ${FontWeight.Light};
`;

export const ArrowsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
`;

export const ArrowButton: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  height: 16px;

  & + & {
    margin-left: 24px;
  }
`;
